import React from 'react';
import { useCustomComponentStateContext } from '../../hooks/useCustomComponentState';
import Star from './Star';

const RATING_MAX = 5;
const RATING_MIN = 0;

const getRoundedNumberInRange = (n: number) => {
  const roundedNumber = Math.round(n * 2) / 2;

  if (roundedNumber < RATING_MIN) return RATING_MIN;
  if (roundedNumber > RATING_MAX) return RATING_MAX;

  return roundedNumber;
};

export interface RatingProps {
  numberStars?: number;
}

function ProductRating({ numberStars }: RatingProps) {
  const { state } = useCustomComponentStateContext();

  const retailerTheme = state?.queryData?.retailerTheme;

  const iconsPrimaryNone: unknown = retailerTheme?.iconsPrimaryNone || {};
  const productrecsrecratingcontainerNoneNone: unknown =
    retailerTheme?.productrecsrecratingcontainerNoneNone || {};
  const productrecsrecratingstarFullNone: unknown =
    retailerTheme?.productrecsrecratingstarFullNone || iconsPrimaryNone || {};
  const productrecsrecratingstarEmptyNone: unknown =
    retailerTheme?.productrecsrecratingstarEmptyNone || iconsPrimaryNone || {};

  if (typeof numberStars !== 'number') return null;

  const rating = getRoundedNumberInRange(numberStars);
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 >= 0.5;
  const emptyStars = RATING_MAX - fullStars - (hasHalfStar ? 1 : 0);

  return (
    <div
      style={{
        padding: 0,
        display: 'flex',
        justifyContent: 'center',
        ...(productrecsrecratingcontainerNoneNone &&
        typeof productrecsrecratingcontainerNoneNone === 'object'
          ? productrecsrecratingcontainerNoneNone
          : {}),
      }}
    >
      {Array.from({ length: fullStars }).map((_, index) => (
        <Star
          full
          s={
            productrecsrecratingstarFullNone &&
            typeof productrecsrecratingstarFullNone === 'object'
              ? productrecsrecratingstarFullNone
              : {}
          }
          key={`full-${index}`}
        />
      ))}

      {hasHalfStar && (
        <Star
          half
          s={
            productrecsrecratingstarFullNone &&
            typeof productrecsrecratingstarFullNone === 'object'
              ? productrecsrecratingstarFullNone
              : {}
          }
          key="half"
        />
      )}

      {Array.from({ length: emptyStars }).map((_, index) => (
        <Star
          s={
            productrecsrecratingstarEmptyNone &&
            typeof productrecsrecratingstarEmptyNone === 'object'
              ? productrecsrecratingstarEmptyNone
              : {}
          }
          key={`empty-${index}`}
        />
      ))}
    </div>
  );
}

export default ProductRating;
